import { FC, useEffect, useContext, useState, useLayoutEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { format } from "date-fns";

import useFetch from "src/hooks/useFetch";
import { APIEndpoints } from "src/types/apiTypes";
import { ToastContext } from "src/context/toastContext";
import { LoaderContext } from "src/context/loaderContext";
import { ToastTypes } from "src/types";

import { StatisticsSearchProps } from "src/components/manufacturer/statistics/types";
import { AuthContext } from "../../context/authContext";

import { StatisticsApiResponse } from "../manufacturer/types";
import AllproductsDistrict from "src/components/manufacturer/allProductDistrict";
import ZilrettaDistrict from "src/components/manufacturer/zilrettaDistrict";
import IoveraDistrict from "src/components/manufacturer/ioveraDistrict";
import FooterText from "src/components/footerText";
import { calculateDrugValueBasedOnParams } from "src/helpers/stats";
import { isZilrettaUser } from "src/helpers";


const District: FC = (): JSX.Element => {
  const { showToast } = useContext(ToastContext);
  const { setLoader, hideLoader } = useContext(LoaderContext);
  const { userData, destroySession } = useContext(AuthContext);
  const navigate = useNavigate()
  const [searchParams, updateSearchParams] = useSearchParams();
  // const location = useLocation();
  // const params = new URLSearchParams(location.search);
  const insuranceName: string | null = searchParams.get('insurance_name');
  // const [drug,setDrugName] = useState<string>(params.get('drug') || "");

  const [queryParams, changeQueryParams] = useState({
    start_date:
      searchParams.get("start_date") ||
      format(new Date().setDate(new Date().getDate() - 30), "yyyy-MM-dd"),
    end_date:
      searchParams.get("end_date") ||
      format(new Date().setDate(new Date().getDate() + 1), "yyyy-MM-dd"),
    period: searchParams.get('period') || "day",
    filter_type: searchParams.get("filter") || "",
    // time: searchParams.get("time") || "",
    type: "index",
    role: searchParams.get("role") || (userData ? userData.ref_type.toLowerCase() : "district_manager"),
    soc_value: searchParams.get("soc_value") || "",
    drug_id: searchParams.get("drug_id") || isZilrettaUser(userData) ? "zilretta" : "",
    id: searchParams.get("userId") || (userData && userData.ref_type?.toLowerCase() !== "manufacturer" ? userData.id.toString() : "") || "",
    insurance_name: insuranceName,
    case_id: "",
    global_patient_id: ""
  });
  //  const tabs = [
  //   { id: "all products", label: "All Products", drugId: "", component: AllproductsDistrict, specialClass: '', btnClass: 'allproduct-btn' },
  //   { id: "zilretta", label: "ZILRETTA", drugId: "ZILRETTA", component: ZilrettaDistrict, specialClass: 'zilretta-content', btnClass: 'zilretta-btn' },
  //   { id: "iovera", label: "iovera°", drugId: "iovera°", component: IoveraDistrict, specialClass: 'iovera-content', btnClass: 'iovera-btn' },
  // ];
  // const [activeTab, setActiveTab] = useState(isZilrettaUser(userData) ? tabs[1].id : searchParams.get("drug") || tabs[0].id);
  // // eslint-disable-next-line @typescript-eslint/no-unused-vars
  // const [activeDrug, setActiveDrug] = useState(isZilrettaUser(userData) ? tabs[1].drugId : searchParams.get("drug") || tabs[0].drugId);
  type TabItem = ReturnType<typeof getTabs>[number];

  const getTabs = (
    is_iovera_user: boolean,
    is_zilretta_user: boolean,
    ref_type: string
  ) => {
    const allTabs = [
      {
        id: "all products",
        label: "All Products",
        drugId: "",
        component: AllproductsDistrict,
        specialClass: "",
        btnClass: "allproduct-btn",
      },
      {
        id: "zilretta",
        label: "ZILRETTA",
        drugId: "ZILRETTA",
        component: ZilrettaDistrict,
        specialClass: "zilretta-content",
        btnClass: "zilretta-btn",
      },
      {
        id: "iovera",
        label: "iovera°",
        drugId: "iovera°",
        component: IoveraDistrict,
        specialClass: "iovera-content",
        btnClass: "iovera-btn",
      },
    ];

    // CASE 1: Manufacture or fam_rm → always show ALL tabs
    if (((ref_type === "Manufacturer" ||  ref_type === "fam_rm") && (userData && !userData.is_jnj))) {
      return allTabs;
    } else {
      const filteredTabs = []; // Always include All Products

      if (is_zilretta_user) filteredTabs.push(allTabs[1]);
      if (is_iovera_user) filteredTabs.push(allTabs[2]);
      if(userData && userData.is_jnj) filteredTabs.push(allTabs[1]);
      if (filteredTabs.length === 0) return allTabs;
      return filteredTabs;
    }

    // CASE 2: Dynamic based on permissions

  };
  const tabs = userData && getTabs(userData.is_iovera_user, userData.is_zilretta_user, userData.ref_type);

  console.log("tabs", tabs)
    const [activeTab, setActiveTab] = useState<string | null>(
    (((userData?.ref_type === "Manufacturer" ||  userData?.ref_type === "fam_rm") && (!userData.is_jnj))) ?
      (tabs && tabs.length > 0 ? tabs[0].id : null)
      : isZilrettaUser(userData) ? (tabs && tabs.length > 0 ? tabs[0]?.id : null) : searchParams.get("drug") || (tabs && tabs.length > 0 ? tabs[0].id : null));
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [activeDrug, setActiveDrug] = useState(
    (((userData?.ref_type === "Manufacturer" ||  userData?.ref_type === "fam_rm") && (!userData.is_jnj))) ?
      tabs && tabs.length > 0 && tabs[0].id
      : isZilrettaUser(userData) ? (tabs && tabs.length > 0 && tabs[0].drugId) : searchParams.get("drug") || (tabs && tabs.length > 0 && tabs[0].drugId));

  //const [activeTab, setActiveTab] = useState(isZilrettaUser(userData) ? (tabs && tabs.length > 0 && tabs[1].id) : searchParams.get("drug") || (tabs && tabs.length > 0 && tabs[0].id));
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  //const [activeDrug, setActiveDrug] = useState(isZilrettaUser(userData) ? (tabs && tabs.length > 0 && tabs[1].drugId) : searchParams.get("drug") || (tabs && tabs.length > 0 && tabs[0].drugId));
  
  useEffect(() => {
    const drug = searchParams.get("drug")
    console.log("Product", drug)
    if (drug)
      setActiveTab(drug.toLowerCase())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const { data: statisticsData, mutate: getStatsData } =
    useFetch<StatisticsApiResponse>(APIEndpoints.MANUFACTURE_STATISTICS, queryParams);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useLayoutEffect(() => setLoader(), [])

  useEffect(() => {
    if (statisticsData) {
      hideLoader();
      if (statisticsData.message && statisticsData.message.includes("User is a physician user")) {
        showToast(["Your session is expred. Please sign in again to continue", "Your role has been updated from another session."], ToastTypes.INFO)
        destroySession()
        navigate("/users/sign_in")
      }
      if (statisticsData.code === 200) {
        showToast([statisticsData.message], ToastTypes.SUCCESS);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statisticsData]);



  const updateQueryParamsAndCallAPI = (
    updatedQueries: StatisticsSearchProps,
    isReset: boolean = false
  ): void => {
    if (isReset) {
      updateSearchParams({});
      changeQueryParams({
        start_date: format(
          new Date().setDate(new Date().getDate() - 30),
          "yyyy-MM-dd"
        ),
        end_date: format(
          new Date().setDate(new Date().getDate()),
          "yyyy-MM-dd"
        ),
        period: "",
        filter_type: "",
        // time: "",
        type: "index",
        role: userData ? userData.ref_type.toLowerCase() : searchParams.get("role") || "district_manager",
        soc_value: "",
        drug_id: updatedQueries.drug_id ? updatedQueries.drug_id : "",
        id: "",
        insurance_name: '',
        case_id: '',
        global_patient_id: ""
      });
    } else {
      changeQueryParams(updatedQueries);
    }

    setLoader();
    getStatsData({}, {}, updatedQueries);
  };

  const getStatisticsData = () => {
    const updatedQueries = {
      ...queryParams,
      drug_id: calculateDrugValueBasedOnParams(searchParams.get("drug")),
    }
    // setDrugName(drug);
    changeQueryParams(updatedQueries)
    setLoader()
    getStatsData({}, {}, updatedQueries);
  }

  const getDrugData = (drug: string) => {
    const updatedQueries = {
      ...queryParams,
      drug_id: drug
    }
    // setDrugName(drug);
    changeQueryParams(updatedQueries)
    setLoader()
    getStatsData({}, {}, updatedQueries)
  }

  const handleTabClick = (tab: TabItem) => {
    setActiveTab(tab.id);
    setActiveDrug(tab.drugId);
    getDrugData(tab.drugId); // still call your API
  };


  // return (
  //   <div className="overflow-y-auto overflow-x-hidden d-flex flex-column flex-fill">
  //     <div className="container-fluid pt-3 d-flex flex-column flex-fill">
  //       {/* Tabs */}
  //       <div className="nav nav-pills gap-2 sticky-top bg-white p-2 rounded-2 border shadow-sm z-1" id="pills-tab">
  //         {tabs.map((tab) => (
  //           <button
  //             key={tab.id}
  //             className={`nav-link ${tab.btnClass} ${activeTab === tab.id ? "active" : ""}`}
  //             id={`${tab.id}-tab`}
  //             type="button"
  //             onClick={() => handleTabClick(tab)}
  //           >
  //             {tab.label}
  //           </button>
  //         ))}
  //       </div>

  //       {/* Tab Content */}
  //       <div className="tab-content d-flex flex-column flex-fill" id="pills-tabContent">
  //         {tabs.map((tab) => {
  //           const TabComponent = tab.component;
  //           return (
  //             <div
  //               key={tab.id}
  //               className={`tab-pane fade flex-fill ${tab.specialClass} ${activeTab === tab.id ? "show active" : ""
  //                 }`}
  //               id={tab.id}
  //             >
  //               {statisticsData && (
  //                 <TabComponent
  //                   updateQueryParamsAndCallAPI={updateQueryParamsAndCallAPI}
  //                   statisticsData={statisticsData}
  //                   getStatisticsData={getStatisticsData}
  //                   queryParams={queryParams}
  //                   drug={tab.label} // 👈 here you can also pass activeDrug instead
  //                 />
  //               )}
  //             </div>
  //           );
  //         })}
  //       </div>
  //     </div>

  //     <FooterText footerType="black" />
  //   </div>
  // );
  // return (
  //     <div 
  //       className={`container-fluid body-bg overflow-y-auto ${drug === "iovera" ? 'iovera-content' : drug === "ZILRETTA" ? 'zilretta-content' : ''}`} >
  //       <div className="container py-4">
  //         <AuthMaunfacturerSubHeader/>
  //         {statisticsData && (
  //             <CaseFilter
  //                 defaultQueryParams={queryParams}
  //                 updateQueryParams={updateQueryParamsAndCallAPI}
  //                 drug={drug}
  //             />
  //         )}
  //         {statisticsData && (
  //             <CaseVolume startDate={queryParams.start_date} endDate={queryParams.end_date} StatisticsObjectType={statisticsData.data} getStatisticsData={getStatisticsData}
  //                         buttonShows={false} drug={''}/>
  //         )}
  //         <div>
  //           {statisticsData &&
  //               <CustomPieChart pieChartObject={statisticsData.data.top_payors} title={'Top 10 Payors'}/>}
  //         </div>
  //         {statisticsData && drug && (
  //             <CustomComponentAreaCaseBySubmission startDate={queryParams.start_date} endDate={queryParams.end_date} StatisticsObjectType={statisticsData.data} title={'Territories'} drug={drug}/>
  //         )}

  //         {statisticsData?.data && (
  //             <GeographicalStatistics
  //                 GeographicalStatisticsListType={
  //                   statisticsData?.data
  //                       .geographical_stats as unknown as GeographicalStatisticsObject[]
  //                 }
  //             />
  //         )}
  //       </div>
  //     </div>
  // );
  return (
    <div className="overflow-y-auto overflow-x-hidden d-flex flex-column flex-fill">
      <div className="container-fluid pt-3 d-flex flex-column flex-fill">
        {/* Tabs */}
        <div
          className="nav nav-pills gap-2 sticky-top bg-white p-2 rounded-2 border shadow-sm"
          id="pills-tab"
        >
          {tabs && tabs.length > 0 && tabs
            // .filter((tab) =>
            //   ((userData?.ref_type === "Manufacturer" ||  userData?.ref_type === "fam_rm") && (!userData.is_jnj)) ? true : (isZilrettaUser(userData) || (!userData.is_jnj)) ? tab.id.toLowerCase() === "zilretta" : true
            // )
            .map((tab) => (
              <button
                key={tab.id}
                className={`nav-link ${tab.btnClass} ${activeTab === tab.id ? "active" : ""
                  }`}
                id={`${tab.id}-tab`}
                type="button"
                onClick={() => handleTabClick(tab)}
              >
                {tab.label}
              </button>
            ))}
        </div>

        {/* Tab Content */}
        <div
          className="tab-content d-flex flex-column flex-fill"
          id="pills-tabContent"
        >
          {tabs && tabs.length > 0 && tabs
            // .filter((tab) =>
            //   ((userData?.ref_type === "Manufacturer" ||  userData?.ref_type === "fam_rm") && (!userData.is_jnj)) ? true : (isZilrettaUser(userData) || (!userData.is_jnj)) ? tab.id.toLowerCase() === "zilretta" : true
            // )
            .map((tab) => {
              const TabComponent = tab.component;
              return (
                <div
                  key={tab.id}
                  className={`tab-pane fade flex-fill ${tab.specialClass} ${activeTab === tab.id ? "show active" : ""
                    }`}
                  id={tab.id}
                >
                  {statisticsData && statisticsData.data && activeTab === tab.id ? (
                    <TabComponent
                      updateQueryParamsAndCallAPI={updateQueryParamsAndCallAPI}
                      statisticsData={statisticsData}
                      getStatisticsData={getStatisticsData}
                      queryParams={queryParams}
                      drug={tab.id}
                    />
                  ) : null}
                </div>
              );
            })}
        </div>
      </div>

      {/* Tab Content */}
      {/* <div
        className="tab-content d-flex flex-column flex-fill"
        id="pills-tabContent"
      >
        {tabs && tabs.length > 0 && tabs
          .filter((tab) =>
            isZilrettaUser(userData) ? tab.id.toLowerCase() === "zilretta" : true
          )
          .map((tab) => {
            const TabComponent = tab.component;
            return (
              <div
                key={tab.id}
                className={`nav-link ${tab.btnClass} ${activeTab === tab.id ? "active" : ""
                  }`}
                id={`${tab.id}-tab`}
                type="button"
                onClick={() => handleTabClick(tab)}
              >
                {statisticsData && statisticsData.data && activeTab === tab.id ? (
                  <TabComponent
                    updateQueryParamsAndCallAPI={updateQueryParamsAndCallAPI}
                    statisticsData={statisticsData}
                    getStatisticsData={getStatisticsData}
                    queryParams={queryParams}
                    drug={tab.id}
                  />
                ) : null}
              </div>
            );
          })}
      </div> */}
    {/* </div> */}

        {/* Tab Content */}
        {/* <div
          className="tab-content d-flex flex-column flex-fill"
          id="pills-tabContent"
        >
          {tabs && tabs.length > 0 && tabs
            .filter((tab) =>
              (userData?.ref_type === "Manufacturer" ||  userData?.ref_type === "fam_rm") ? true :isZilrettaUser(userData) ? tab.id.toLowerCase() === "zilretta" : true
            )
            .map((tab) => {
              const TabComponent = tab.component;
              return (
                <div
                  key={tab.id}
                  className={`tab-pane fade flex-fill ${tab.specialClass} ${activeTab === tab.id ? "show active" : ""
                    }`}
                  id={tab.id}
                >
                  {statisticsData && statisticsData.data && activeTab === tab.id ? (
                    <TabComponent
                      updateQueryParamsAndCallAPI={updateQueryParamsAndCallAPI}
                      statisticsData={statisticsData}
                      getStatisticsData={getStatisticsData}
                      queryParams={queryParams}
                      drug={tab.id}
                    />
                  ) : null}
                </div>
              );
            })}
        </div>
      </div> */}

      <FooterText footerType="black" />
    </div>
  );
};

export default District;
